module.exports = __webpack_public_path__ + "img/ic_web_light.87680597.svg";